import _ from 'lodash';
import { Input, Form } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Navigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import rubusLogo from '../../../images/horizontal_logo.png';
import LoginAction from '../../../modules/actions/LoginAction';
import TranslationAction from '../../../modules/actions/TranslationAction';
import { UserOutlined, LockOutlined, AimOutlined } from '@ant-design/icons';
import {
  HeaderLogo,
  Welcome,
  LoginButton,
  WelcomeModule,
  LoginPageBackground,
  LoginBox,
  LoginSection,
  Login
} from './styles';

const LoginComponent = ({ location, accessToken, loginAction, translationCache, navigate }) => {
  const [siteName, setSiteName] = useState('');
  const [showSite, setShowSite] = useState(false);

  useEffect(() => {
    const path = location.pathname.split('/login/');
    if (path && path[1]) {
      setSiteName(path[1]);
      setShowSite(false);
    } else {
      setShowSite(true);
    }
  }, [location.pathname]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onFinish = (values) => {
    if (!showSite) {
      values = { ...values, siteName };
    }
    loginAction.userLoginAuth(values, { navigate });
  };

  if (accessToken && accessToken !== 'undefined' && accessToken !== 'null') {
    return <Navigate to="/rubus/LandingPage" />;
  }

  return (
    <Login>
      <LoginSection>
        <LoginPageBackground style={{ backgroundImage: `url('/covers/rubus_login.jpg')` }} />
        <LoginBox>
          <section>
            <HeaderLogo>
              <img src={rubusLogo} alt="logo" style={{ height: '60px' }} />
            </HeaderLogo>

            <Welcome style={{  color: '#444343' }}>
              {translation('Welcome back, sign in with your account')}
            </Welcome>
            {showSite === false ? (
              <WelcomeModule>{`${_.startCase(_.toLower(siteName))} Application`}</WelcomeModule>
            ) : null}

            <Form name={translation('login')} onFinish={onFinish} autoComplete="off">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  {showSite && (
                    <Form.Item
                      name={translation('siteName')}
                      rules={[
                        { required: true, message: translation('Please input your Site Name') }
                      ]}>
                      <Input
                        style={{ width: '380px' }}
                        prefix={<AimOutlined />}
                        placeholder={translation('Site Name')}
                      />
                    </Form.Item>
                  )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Form.Item
                    name="identifier"
                    rules={[
                      {
                        required: true,
                        message: translation('Please input your username/email/mobilenumber!!')
                      }
                    ]}>
                    <Input
                      style={{ width: '380px' }}
                      prefix={<UserOutlined className="site-form-item-icon" />}
                      placeholder={translation('Username/Email/Mobilenumber!!')}
                    />
                  </Form.Item>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Form.Item
                    name="password"
                    rules={[
                      { required: true, message: translation('Please input your password!') }
                    ]}>
                    <Input.Password
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      style={{ width: '380px' }}
                      placeholder={translation('Password')}
                    />
                  </Form.Item>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Form.Item>
                    <LoginButton type="primary" htmlType="submit">
                      {translation('Log in')}
                    </LoginButton>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </section>
        </LoginBox>
      </LoginSection>
    </Login>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginAction: bindActionCreators(LoginAction, dispatch),
    TranslationAction: bindActionCreators(TranslationAction, dispatch)
  };
};

const mapStateToProps = (state) => {
  return {
    accessToken: state.LoginReducer.accessToken
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginComponent);